import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { C as ComponentErrorCodes, a as ComponentErrorSeverity } from './ComponentError.js';
import { m as makeGetBusiness, a as makePatchBusiness } from './payment-provisioning-actions.js';
import { B as BusinessService } from './business.service.js';
import { d as defineCustomElement$b } from './form-control-date2.js';
import { d as defineCustomElement$a } from './form-control-error-text2.js';
import { d as defineCustomElement$9 } from './form-control-help-text2.js';
import { d as defineCustomElement$8 } from './form-control-number-masked2.js';
import { d as defineCustomElement$7 } from './form-control-select2.js';
import { d as defineCustomElement$6 } from './form-control-text2.js';
import { d as defineCustomElement$5 } from './business-owners-form-step-core.js';
import { d as defineCustomElement$4 } from './identity-address-form.js';
import { d as defineCustomElement$3 } from './owner-form.js';
import { d as defineCustomElement$2 } from './owner-form-core2.js';
import { d as defineCustomElement$1 } from './owner-form-inputs2.js';

const BusinessOwnersFormStep = /*@__PURE__*/ proxyCustomElement(class BusinessOwnersFormStep extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.errorEvent = createEvent(this, "error-event", 7);
        this.getBusiness = undefined;
        this.patchBusiness = undefined;
        this.authToken = undefined;
        this.businessId = undefined;
        this.allowOptionalFields = undefined;
    }
    propChanged() {
        this.initializeApi();
    }
    async validateAndSubmit({ onSuccess }) {
        this.coreComponent.validateAndSubmit({ onSuccess });
    }
    componentWillLoad() {
        this.initializeApi();
    }
    initializeApi() {
        if (this.authToken && this.businessId) {
            this.getBusiness = makeGetBusiness({
                authToken: this.authToken,
                businessId: this.businessId,
                service: new BusinessService()
            });
            this.patchBusiness = makePatchBusiness({
                authToken: this.authToken,
                businessId: this.businessId,
                service: new BusinessService()
            });
        }
        else {
            this.errorEvent.emit({
                message: 'Missing required props',
                errorCode: ComponentErrorCodes.MISSING_PROPS,
                severity: ComponentErrorSeverity.ERROR,
            });
        }
    }
    render() {
        return (h(Host, { key: '213a68fd3543eb912c6fed376128ba877ba75871' }, h("justifi-business-owners-form-step-core", { key: '5acee797bd35f5b60cadc5ddd50f560532dfe8b1', authToken: this.authToken, businessId: this.businessId, getBusiness: this.getBusiness, patchBusiness: this.patchBusiness, allowOptionalFields: this.allowOptionalFields, ref: (el) => this.coreComponent = el })));
    }
    static get watchers() { return {
        "authToken": ["propChanged"],
        "businessId": ["propChanged"]
    }; }
}, [0, "justifi-business-owners-form-step", {
        "authToken": [1, "auth-token"],
        "businessId": [1, "business-id"],
        "allowOptionalFields": [4, "allow-optional-fields"],
        "getBusiness": [32],
        "patchBusiness": [32],
        "validateAndSubmit": [64]
    }, undefined, {
        "authToken": ["propChanged"],
        "businessId": ["propChanged"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["justifi-business-owners-form-step", "form-control-date", "form-control-error-text", "form-control-help-text", "form-control-number-masked", "form-control-select", "form-control-text", "justifi-business-owners-form-step-core", "justifi-identity-address-form", "justifi-owner-form", "owner-form-core", "owner-form-inputs"];
    components.forEach(tagName => { switch (tagName) {
        case "justifi-business-owners-form-step":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BusinessOwnersFormStep);
            }
            break;
        case "form-control-date":
            if (!customElements.get(tagName)) {
                defineCustomElement$b();
            }
            break;
        case "form-control-error-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "form-control-help-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "form-control-number-masked":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "form-control-select":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "form-control-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "justifi-business-owners-form-step-core":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "justifi-identity-address-form":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "justifi-owner-form":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "owner-form-core":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "owner-form-inputs":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { BusinessOwnersFormStep as B, defineCustomElement as d };
